module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "avaliacao-tema"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box pa-3"
  }, [_c('v-radio-group', {
    staticClass: "ma-0 pa-3 lista-temas",
    model: {
      value: (_vm.tema),
      callback: function($$v) {
        _vm.tema = $$v
      },
      expression: "tema"
    }
  }, _vm._l((_vm.temas), function(tema, i) {
    return _c('div', [_c('v-radio', {
      key: tema.titulo,
      attrs: {
        "color": "primary",
        "value": tema
      },
      scopedSlots: _vm._u([{
        key: "label",
        fn: function() {
          return [_c('div', [_c('h3', {
            staticClass: "title font-weight-regular black--text mb-1"
          }, [_vm._v(_vm._s(tema.titulo))]), _vm._v("\n              ("), _c('a', {
            attrs: {
              "href": tema.enunciado,
              "target": "_blank"
            }
          }, [_vm._v("Clique aqui para visualizar o enunciado")]), _vm._v(")\n            ")])]
        },
        proxy: true
      }], null, true)
    }), _vm._v(" "), (i !== _vm.temas.length - 1) ? _c('v-divider', {
      staticClass: "my-3"
    }) : _vm._e()], 1)
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "text-xs-right"
  }, [_c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "color": "primary",
      "depressed": "",
      "large": ""
    },
    on: {
      "click": function($event) {
        return _vm.continuar()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-arrow-circle-right"
  }), _vm._v(" "), _c('span', {
    staticClass: "pl-1"
  }, [_vm._v("Continuar")])])], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-content"
  }, [_c('div', {
    staticClass: "page-header-content"
  }, [_c('h2', {
    staticClass: "page-title"
  }, [_vm._v("Selecione o tema")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2cda9360!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/domains/avaliacao/components/Tema.vue
// module id = 533
// module chunks = 2